import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, ref, Ref } from 'vue';
import { useRoute } from 'vue-router/composables';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  Row,
  HeadingDisplay,
  ListDisplay,
  SkeletonLoader,
  ButtonContainer,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';
import { InputMoney } from '@/modules/transaction/components/InputMoney';

import {
  getWithdrawAmount,
  IWithdrawDetailsV2
} from '@/modules/transaction/services/product-withdraw';

import { errorText, listDetails, EProductTypes } from './helpers';
import { debounce } from 'lodash-es';
import ModalAvailableForRedemption from './components/ModalAvailableForRedemption/ModalAvailableForRedemption.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'WithdrawStepV2',
  setup(__props) {

const route = useRoute();

const withdrawDetails = inject('withdrawDetailsV2') as Ref<IWithdrawDetailsV2>;
const isFetchingReview = inject('isFetchingReview') as Ref<boolean>;
const productId = inject('productId') as Ref<string>;

const fetchWithdrawReview = inject('fetchWithdrawReview', (amount: number) => ({
  amount
}));

const updateValue = ref(false);
const isLoadingAmount = ref(false);
const netBalance = ref('R$ 0,00');
const isButtonDisabled = ref(false);
const modalIsOpen = ref(false);

const withdrawInput = ref({
  value: 0,
  formatted: ''
});

const productType = computed(() => {
  const { type } = route.params;
  return type;
});

const helperText = computed(() => {
  return errorText(
    withdrawDetails.value,
    withdrawInput.value.value,
    productType.value
  );
});

const details = computed(() => {
  return listDetails(
    withdrawDetails.value,
    netBalance.value,
    productType.value,
    isLoadingAmount.value
  );
});

const showButtons = computed(() => {
  return productType.value !== EProductTypes.FUNDS;
});

const shortcuts = computed(() => {
  return productType.value === EProductTypes.FUNDS
    ? withdrawDetails.value.buttons
    : [];
});

const incrementValue = computed((): number => {
  return withdrawDetails.value.increment.value;
});

const minimumWithdraw = computed(() => {
  return withdrawDetails.value.minimumRedemption.value;
});

const totalBalance = computed(() => {
  return withdrawDetails.value.availableToRedemption.value;
});

const isDisabled = computed(() => {
  return (
    withdrawInput.value.value <= 0 ||
    helperText.value !== '' ||
    isButtonDisabled.value
  );
});

const debounceChangeValue = debounce(async data => {
  onChangeValue(data);
}, 500);

function onChangeValue(data: {
  value: number;
  formatted: string;
  increment: boolean;
}) {
  withdrawInput.value = data;
  netBalance.value = 'R$ 0,00';
  isButtonDisabled.value = true;

  if (data.increment) {
    const isTotal = data.value === totalBalance.value;
    const meetsMinimum = data.value >= minimumWithdraw.value;

    if (isTotal || meetsMinimum) {
      fetchWithdrawAmount(data.value);
    }
  }
}

function handleClick() {
  fetchWithdrawReview(withdrawInput.value.value);
}

function handleBlur() {
  const value = withdrawInput.value.value;
  const isTotal = value === totalBalance.value;

  if (value < minimumWithdraw.value && !isTotal) {
    netBalance.value = 'R$ 0,00';
    return;
  }

  fetchWithdrawAmount(value);
}

async function fetchWithdrawAmount(amount: number) {
  isLoadingAmount.value = true;

  try {
    const data = await getWithdrawAmount(productId.value, amount);

    netBalance.value = data.netBalance.formatted;

    isButtonDisabled.value = false;
  } catch (e) {
    console.error(e);
  } finally {
    isLoadingAmount.value = false;
  }
}

function openModal() {
  modalIsOpen.value = true;
}

function closeModal() {
  modalIsOpen.value = false;
}

return { __sfc: true,route, withdrawDetails, isFetchingReview, productId, fetchWithdrawReview, updateValue, isLoadingAmount, netBalance, isButtonDisabled, modalIsOpen, withdrawInput, productType, helperText, details, showButtons, shortcuts, incrementValue, minimumWithdraw, totalBalance, isDisabled, debounceChangeValue, onChangeValue, handleClick, handleBlur, fetchWithdrawAmount, openModal, closeModal, NebraskaColors, BaseText, Row, HeadingDisplay, ListDisplay, SkeletonLoader, ButtonContainer, ButtonPrimary, InputMoney, ModalAvailableForRedemption }
}

})